import ActionButton from "./ActionButton";
import deleteIcon from "../../assets/delete.svg";

function DeleteButton(props) {
  
  return (
    <ActionButton
      {...props}
      icon={deleteIcon}
      className="btn-delete"
      title="Delete"
    />
  );
}

export default DeleteButton;